export default __webpack_public_path__ + "static/N0297-c238811f51a0fb1199473cc3d2501f53.png";